import { define, type, auto } from 'type-r'

import { store } from '../models/store.js'
import View from './view.js'

export const daysName = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

@define
export default class AgendaComponent extends View {
    @auto(null) declare agenda: any

    initialize() {
        this.initAgenda()
    }
    
    initAgenda() {
        this.agenda = this.agendaEl.scrollAgenda({
            first: store.date.getDay(),
            auto: true,
            onRangeChange: (start: number, end: number) => {
                if (start != end) {
                    this.agendaDay.text(daysName[start].substr(0, 3) + ' - ' + daysName[end].substr(0, 3));
                } else {
                    this.agendaDay.text(daysName[start]);
                }
            },
        });

	this.agendaPrev.click((event) => {
	    event.preventDefault();
	    this.agenda.scrollAgendaToPrevious();
	});
	this.agendaDay.click((event) => {
	    event.preventDefault();
	    this.agenda.scrollAgendaFirstColumn(2);
	});
	this.agendaNext.click((event) => {
	    event.preventDefault();
	    this.agenda.scrollAgendaToNext();
	});
    }

    get agendaPrev() {
        return $(this.el).find('#agenda-previous');
    }

    get agendaToday() {
        return $(this.el).find('#agenda-today');
    }

    get agendaNext() {
        return $(this.el).find('#agenda-next');
    }
    
    get agendaEl() {
        return $(this.el).find('#agenda')        
    }
    
    get agendaDay() {
        return $(this.el).find('#agenda-day');        
    }

    get content() {
        return $(this.el).find('#agenda-content');
    }
    
    show() {
        $.ajax({
            url: '/getcal?week=' + (store.date.getTime() / 1000),
            success: data => {
                this.content.html(data);
                if (!this.visible)
                    $(this.el).show();
                this.initAgenda();
            }
        });        
    }
    
    hide() {
        $(this.el).hide();
    }
}
